import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllSites, MigrateToArchive } from 'shared/state/ducks/site/operations';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import PageContainer from 'web/view/components/page-container/page-container';
import SkioldTableGrid from 'web/view/components/skiold-components/skiold-table/skiold-table-grid/skiold-table-grid';
import { SkioldTouchableOpacity } from 'web/view/components/skiold-components/skiold-touchable-opacity';
import { SkioldIconSpinner } from 'web/view/components/utils/skiold-icon-spinner';
import { ViewWeb } from 'web/view/components/utils/web-view';
import sokort_icon from 'shared/assets/src-assets/png/sokort_icon.png';
import { showAlert, ShowConfirmAlert } from 'web/view/components/skiold-alert/skiold-alert';
interface PropsFromParent {}

export const CurrentSitesToArchive: FC<PropsFromParent> = React.memo(() => {
	const dispatch = useDispatch();
	const [selectedSite, setSelectedSiteId] = React.useState<string>();

	// get redux data
	const sites = useSelector((state: WebAppState) => state.site.sites);
	const isLoading = useSelector((state: WebAppState) => state.site.isLoading);
	//initialize the component
	useEffect(() => {
		dispatch(GetAllSites());
	}, [dispatch]);

	const tableData = useMemo(() => {
		return sites.map(site => {
			return {
				name: site.siteName,
				id: site.id,
			};
		});
	}, [sites]);

	const migrateButton = useCallback(
		(siteRow: any) => {
			const onPress = async () => {
				if (!(await ShowConfirmAlert(localized('AreYouSureYouWantToMigrateSiteToArchive')))) {
					return;
				}
				setSelectedSiteId(siteRow.id);
				dispatch(MigrateToArchive(siteRow.id, showAlert));
			};
			return (
				<SkioldIconSpinner
					title={''}
					icon={sokort_icon}
					onPress={onPress}
					showSpinnerControlled={selectedSite === siteRow.id && isLoading}
					clipSize={30}
					width={30}
					height={30}
				/>
			);
		},
		[isLoading, selectedSite],
	);

	const columns = useMemo(() => {
		return [
			{
				name: 'name',
				title: localized('SiteName'),
			},
			{
				name: 'migrate',
				title: localized('Migrate'),
				getCellValue: migrateButton,
			},
		];
	}, [isLoading, selectedSite]);

	const columnExtensions = useMemo(() => {
		return [
			{ columnName: 'name', width: 300 },
			{ columnName: 'migrate', width: 80 },
		];
	}, []);

	return (
		<SkioldTableGrid
			data={tableData}
			columns={columns}
			ColumnExtensions={columnExtensions}
			tableKey="current-site-overview"
		/>
	);
});
